export default __webpack_public_path__ + "static/media/on.dd6ae378.mp3";